import { VflWidgets } from "app/Components/EhsDashboard/Global/Widgets";
import React, { useCallback, useEffect, useState } from "react";
import { GrSchedules } from "react-icons/gr";
import { AiOutlineFileDone } from "react-icons/ai";
// import { TfiStackOverflow } from "react-icons/tf";
import { FaUserClock, FaStackOverflow } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import RightFilter from "../Dashboard/RightFilter";
import { GlobalDashboardService } from "app/_services/GlobalDashboardService/GlobalDashboardService";
import PieChartWithModal from "app/Components/PieChartWithModal/PieChartWithModal";

import {
  BarChartCard,
  StackBarChartCard,
  MultipleBarChartCard,
  BasicBarChartWithLabelCard,
  BasicBarChartWithLabelAndCustomToolTipCard,
} from "app/Components/ChartCard/ChartCard";
import {
  pieChartPageTwoList,
  stackAndBarPageOneList,
  stackAndBarPageTwoList,
} from "./Constants";
import DashboardNav from "../Dashboard/Comman/DashboardNav";
import {
  barChartDataFormat,
  BasicBarChartWithLabelDataFormat,
  BasicBarChartWithLabelDataFormatForCustomToolTip,
  BasicBarChartWithLabelMonthDataFormat,
  multipleBarChartDataFormat,
  pieChartDataWithModal,
  pieChartDataWithModalForTotalVs,
  stackChartDataFormat,
} from "../Dashboard/Comman/config";
import {
  IS_USER_SITE_HO,
  IS_USER_SITE_MINES,
  IS_USER_SITE_RO,
} from "../_healthSafetyEnvironment/IncidentManagement/Helper";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import { useSelector } from "react-redux";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const VflDashboard = () => {
  // const [form, setForm] = useState({ ...initialForm });
  const [showFilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [chart, setChart] = useState({});
  const [allSite, setAllSite] = useState([]);
  const [haveAccessToSite, setHaveAccessToSite] = useState([]);
  const [currentSelectedSite, setCurrentSelectedSite] = useState({});
  const [zoomActive, setZoomActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const filterClick = (value) => {
    setShowFilter(value);
  };
  // const onClick = useCallback(({ target: { innerText } }) => {
  //   setForm((prev) => ({ ...prev, dashboardSelect: innerText }));
  // }, []);

  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  useEffect(() => {
    getAllSitesWithAccess().then((res) => {
      setAllSite(res?.data?.availableSites);
    });
  }, []);

  useEffect(() => {
    const getSiteData = allSite?.find((d) => d.id == globalSelectedSiteId);
    setCurrentSelectedSite(getSiteData);
    // pageValueFun(getSiteData?.siteType == 3 ? 2 : 1);
    const haveAccessToSiteArray =
      getSiteData?.siteType == 1
        ? allSite?.map((d) => {
            return d.id;
          })
        : getSiteData?.siteType == 2
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId || d.parentSiteId == globalSelectedSiteId)
                return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : getSiteData?.siteType == 3
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId) return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : [];

    setHaveAccessToSite(haveAccessToSiteArray);
  }, [allSite, globalSelectedSiteId]);

  const dashboardData = useCallback(
    async (filter) => {
      let obj = {
        startDate: filter?.startDate,
        endDate: filter?.endDate,
        siteId: filter?.siteId
          ? filter?.siteId
          : globalSelectedSiteId
          ? haveAccessToSite
          : null,
      };
      if (
        JSON.stringify(obj) === JSON.stringify({ siteId: [] }) ||
        JSON.stringify(obj) === JSON.stringify({ siteId: null })
      ) {
        return;
      }
      let response = await GlobalDashboardService.vflDashboard(obj);
      if (response && response.status && response.data) {
        const dashboardData = response.data;

        //-----------------Pie Chart---------------
        const vflStatusAreaWiseSCheduledChart = pieChartDataWithModal(
          dashboardData?.vflStatusAreaWiseSCheduled
        );
        const vflStatusAreaWiseOverDueChart = pieChartDataWithModal(
          dashboardData?.vflStatusAreaWiseOverDue
        );
        const vflStatusAreaWiseCompletedChart = pieChartDataWithModal(
          dashboardData?.vflStatusAreaWiseCompleted
        );
        const topFiveVFLExecutivesChart = pieChartDataWithModal(
          dashboardData?.topFiveVFLExecutives
        );
        const TopVFLStatusAreaWiseChart = pieChartDataWithModal(
          dashboardData?.TopVFLStatusAreaWise
        );
        // ------------------Stack chart----------------------

        // --------------------Bar chart -------------------
        const vflScheduledHOChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflScheduledHO
        );
        const vflCompletedHOChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflCompletedHO
        );
        const vflOverDueHOChart = pieChartDataWithModalForTotalVs(
          dashboardData?.vflOverDueHO
        );
        const vflOutStandingCAPAsHOChart = pieChartDataWithModalForTotalVs(
          dashboardData?.vflOutStandingCAPAsHO
        );
        const vflOverdueCAPAsHOChart = pieChartDataWithModalForTotalVs(
          dashboardData?.vflOverdueCAPAsHO
        );
        const vflOverDueCAPAsHeadOfficeOnly = pieChartDataWithModalForTotalVs(
          dashboardData?.vflOverDueCAPAsHeadOfficeOnly
        );
        const topFiveVFLExecutivesOverDueChart = pieChartDataWithModalForTotalVs(
          dashboardData?.topFiveVFLExecutivesOverDueChart
        );
        const vflScheduledROChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflScheduledRO
        );
        const vflCompletedROChart = BasicBarChartWithLabelDataFormatForCustomToolTip(
          dashboardData?.vflCompletedRO
        );
        // const vflCompletedROChartCutomToolTip = BasicBarChartWithLabelDataFormatForCustomToolTip(dashboardData?.vflCompletedRO);
        const vflOverDueROChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflOverDueRO
        );
        const vflOutStandingCAPAsRoChart = stackChartDataFormat(
          dashboardData?.vflOutStandingCAPAsRo
        );
        const vflOverdueCAPAsRoChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflOverdueCAPAsRo
        );
        const vflScheduledMinesChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflScheduledMines
        );
        const vflCompletedMinesChart = BasicBarChartWithLabelDataFormatForCustomToolTip(
          dashboardData?.vflCompletedMines
        );
        const vflOverDueMinesChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflOverDueMines
        );

        const vflOutStandingCAPAsMinesChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflOutStandingCAPAsMines
        );
        const vflOverdueCAPAsMinesChart = BasicBarChartWithLabelDataFormat(
          dashboardData?.vflOverdueCAPAsMines
        );
        const last12MonthsChart = BasicBarChartWithLabelMonthDataFormat(
          dashboardData?.last12Months
        );

        // console.log("sdsdsad", vflCompletedROChartCutomToolTip);

        setChart({
          dashboardData: dashboardData,

          //---pie chart----------------------

          vflStatusAreaWiseSCheduledChart: vflStatusAreaWiseSCheduledChart,
          vflStatusAreaWiseOverDueChart: vflStatusAreaWiseOverDueChart,
          vflStatusAreaWiseCompletedChart: vflStatusAreaWiseCompletedChart,
          TopVFLStatusAreaWiseChart: TopVFLStatusAreaWiseChart,
          topFiveVFLExecutivesChart: topFiveVFLExecutivesChart,

          // vflCompletedROChartCutomToolTip: vflCompletedROChartCutomToolTip,
          //---Bar chart----------------------
          vflScheduledHOChart: vflScheduledHOChart,
          topFiveVFLExecutivesOverDueChart: topFiveVFLExecutivesOverDueChart,
          vflCompletedHOChart: vflCompletedHOChart,
          vflOverDueHOChart: vflOverDueHOChart,
          vflOutStandingCAPAsHOChart: vflOutStandingCAPAsHOChart,
          vflOverdueCAPAsHOChart: vflOverdueCAPAsHOChart,
          vflScheduledROChart: vflScheduledROChart,
          vflCompletedROChart: vflCompletedROChart,
          vflOverDueROChart: vflOverDueROChart,
          vflOutStandingCAPAsRoChart: vflOutStandingCAPAsRoChart,
          vflOverdueCAPAsRoChart: vflOverdueCAPAsRoChart,
          vflScheduledMinesChart: vflScheduledMinesChart,
          vflCompletedMinesChart: vflCompletedMinesChart,
          vflOverDueMinesChart: vflOverDueMinesChart,
          vflOutStandingCAPAsMinesChart: vflOutStandingCAPAsMinesChart,
          vflOverdueCAPAsMinesChart: vflOverdueCAPAsMinesChart,
          last12MonthsChart: last12MonthsChart,
          vflOverDueCAPAsHeadOfficeOnly: vflOverDueCAPAsHeadOfficeOnly,
          widgetData: {
            vflScheduledCount: {
              name: "VFL Scheduled",
              value: dashboardData?.vflScheduledCount,
              icon: GrSchedules,
            },
            vflCompletedCount: {
              name: "VFL Completed",
              value: dashboardData?.vflCompletedCount,
              icon: AiOutlineFileDone,
            },
            vflOverDueCount: {
              name: "VFL Overdue",
              value: dashboardData?.vflOverDueCount,
              icon: FaStackOverflow,
            },
            CapaOverdue: {
              name: "CAPAs Overdue",
              value: dashboardData?.overDueCAPAsCount,
              icon: FaUserClock,
            },
          },
        });
      }
      setLoading(false);
      return;
    },
    [globalSelectedSiteId, haveAccessToSite]
  );

  const pageValueFun = (value) => {
    setPage(+value);
  };

  useEffect(() => {
    dashboardData();
  }, [dashboardData]);

  const applyFilter = (filter) => {
    console.log("filter", filter);
    dashboardData(filter);
  };

  // console.log(chart);
  return (
    <>
      <Row>
        <Col lg={showFilter ? 9 : 12}>
          <Row>
            <Col lg={12}>
              <DashboardNav
                screenCount={
                  (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                    ? true
                    : false) || IS_USER_SITE_MINES()
                    ? 1
                    : 2
                }
                pageBool={pageValueFun}
                onFilterBool={filterClick}
                page={page}
                dashboardName="Visible Felt Leadership"
                id={"screen_" + page}
              />
            </Col>
          </Row>
          {!loading ? (
            <>
              {" "}
              {!IS_USER_SITE_MINES() &&
                (globalSelectedSiteId ? currentSelectedSite?.siteType != 3 : true) &&
                page === 1 && (
                  <Row className="screenOne" id={"screen_" + page}>
                    {stackAndBarPageOneList?.map((item, idx) => {
                      if (IS_USER_SITE_HO()) {
                        return item?.type === "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type === "pie" ? (
                          <Col key={idx} md={6} id={"main_" + idx} className="mb-4 pb-2">
                            <PieChartWithModal
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customeTool={item?.customeTool}
                              customToolTip={chart[item?.value]?.customToolTip}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabelAndCustomToolTip" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelAndCustomToolTipCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customToolTip={item?.toolTip}
                              custumToolTipData={chart[item?.value]?.custumToolTipData}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        );
                      } else if (!item?.isHo && !IS_USER_SITE_HO()) {
                        return item?.type === "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type === "pie" ? (
                          <Col key={idx} md={6} id={"main_" + idx} className="mb-4 pb-2">
                            <PieChartWithModal
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customeTool={item?.customeTool}
                              customToolTip={chart[item?.value]?.customToolTip}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabelAndCustomToolTip" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <BasicBarChartWithLabelAndCustomToolTipCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              customToolTip={item?.toolTip}
                              custumToolTipData={chart[item?.value]?.custumToolTipData}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        );
                      }
                    })}
                  </Row>
                )}
              {(((IS_USER_SITE_MINES() ||
                (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                  ? true
                  : false)) &&
                page === 1) ||
                page === 2) && (
                <Row id={"screen_" + page}>
                  <Col lg={12}>
                    <div className="ohscContainer">
                      <div className="widgetContainer mt-3">
                        <VflWidgets
                          isFilterClick={showFilter}
                          widgetData={{ ...chart?.widgetData }}
                        />
                      </div>

                      <div className="chartContainer">
                        <Row>
                          {pieChartPageTwoList.map((item, idx) => (
                            <Col
                              key={idx}
                              md={6}
                              id={"main_" + idx}
                              className="mb-4 pb-2"
                            >
                              <PieChartWithModal
                                title={item.title}
                                id={"main_" + idx}
                                seriesData={chart[item?.value] || []}
                                customLabelFalse={true}
                                isCustomLegend={true}
                                scrollLegend={(item.isScroll && !zoomActive) || false}
                                setZoomActive={setZoomActive}
                                zoomActive={zoomActive}
                              />
                            </Col>
                          ))}

                          {stackAndBarPageTwoList?.map((item, idx) => {
                            return item?.type == "barWithLabel" ? (
                              <Col
                                lg={item?.isMines ? 12 : 6}
                                id={"main_" + idx}
                                className="mb-4 pb-2"
                              >
                                <BasicBarChartWithLabelCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  category={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                              </Col>
                            ) : item?.type == "barWithLabelMonth" ? (
                              <Col
                                lg={item?.isMines ? 12 : 6}
                                id={"main_" + idx}
                                className="mb-4 pb-2"
                              >
                                <BasicBarChartWithLabelCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  // category={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                              </Col>
                            ) : (
                              <Col
                                lg={item?.isMines ? 12 : 6}
                                key={idx}
                                id={"main_" + idx}
                                className="mb-4 pb-2"
                              >
                                <MultipleBarChartCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  category={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <NetZeroLoader addZIndex={true} />
          )}
        </Col>
        <Col lg={2} className={`d-${showFilter ? "block" : "none"}`}>
          <RightFilter applyFilter={applyFilter} />
        </Col>
      </Row>
    </>
  );
};

export default VflDashboard;
